import { getValue } from "@nitro/gatsby-source-harvia-pim/helpers/attribute"
//import useProductCategoryStructure from "@nitro/gatsby-source-harvia-pim/hooks/useProductCategoryStructure"
import { Product } from "@nitro/gatsby-source-harvia-pim/types/plugin"
import React from "react"
import useProductCategoryStructure from "../../../hooks/useProductCategoryStructure"
import ProductComparison from "../../organisms/product/ProductComparison"
import { findDeepestCategory } from "../../organisms/product/utils"
//import * as styles from "./ProductPageComparison.module.scss"

type ProductPageComparisonProps = {
  product: Product
}

/**
 * Kuin ProductComparison, mutta etsii kategoriapuusta tuotteen syvimmän kategorian
 * ja hakee vertailutuotteet siitä kategoriasta ja samasta tuoteperheestä
 * @param product Nykyinen tuote
 * @returns
 */
const ProductPageComparison = (props: ProductPageComparisonProps) => {
  // console.debug("Rendering ProductPageComparison", props)
  const structure = useProductCategoryStructure()
  const familyData = getValue(props.product.values, "product_family")
  const family = familyData?.value[0].data || ""
  const category = findDeepestCategory(structure.subCategories, props.product.categories)?.code

  if (!category || !family) return <ProductComparison product={props.product} />

  return <ProductComparison product={props.product} query={`categories:${category},product_family:${family}`} />
}

export default ProductPageComparison
